// Gallery Images Data
export const galleryImages = [
  {
    id: 1,
    url: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=800&q=80',
    category: 'weddings',
    alt: 'Elegant white tiered wedding cake',
  },
  {
    id: 2,
    url: 'https://images.unsplash.com/photo-1562440499-64c9a111f713?w=800&q=80',
    category: 'birthdays',
    alt: 'Colorful birthday cake with decorative elements',
  },
  {
    id: 3,
    url: 'https://images.unsplash.com/photo-1588195538326-c5b1e5b80e49?w=800&q=80',
    category: 'weddings',
    alt: 'Layered cake with fresh berries',
  },
  {
    id: 4,
    url: 'https://images.unsplash.com/photo-1606890737304-57a1ca8a5b62?w=800&q=80',
    category: 'birthdays',
    alt: 'Chocolate drip cake',
  },
  {
    id: 5,
    url: 'https://images.unsplash.com/photo-1535254973040-607b474cb50d?w=800&q=80',
    category: 'weddings',
    alt: 'Minimalist white wedding cake with greenery',
  },
  {
    id: 6,
    url: 'https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=800&q=80',
    category: 'seasonal',
    alt: 'Berry topped cake',
  },
  {
    id: 7,
    url: 'https://images.unsplash.com/photo-1614707267537-b85aaf00c4b7?w=800&q=80',
    category: 'cupcakes',
    alt: 'Assorted decorated cupcakes',
  },
  {
    id: 8,
    url: 'https://images.unsplash.com/photo-1557925923-33b27ec80d87?w=800&q=80',
    category: 'custom',
    alt: 'Custom designed celebration cake',
  },
  {
    id: 9,
    url: 'https://images.unsplash.com/photo-1571115764595-644a1f56a55c?w=800&q=80',
    category: 'cupcakes',
    alt: 'Chocolate cupcakes with frosting',
  },
  {
    id: 10,
    url: 'https://images.unsplash.com/photo-1558961363-fa8fdf82db35?w=800&q=80',
    category: 'birthdays',
    alt: 'Fun birthday cake design',
  },
  {
    id: 11,
    url: 'https://images.unsplash.com/photo-1565958011703-44f9829ba187?w=800&q=80',
    category: 'seasonal',
    alt: 'Seasonal decorated cake',
  },
  {
    id: 12,
    url: 'https://images.unsplash.com/photo-1600002415506-dd06090d3480?w=800&q=80',
    category: 'custom',
    alt: 'Custom artistic cake design',
  },
  {
    id: 13,
    url: 'https://images.unsplash.com/photo-1555507036-ab1f4038808a?w=800&q=80',
    category: 'birthdays',
    alt: 'Birthday celebration cake',
  },
  {
    id: 14,
    url: 'https://images.unsplash.com/photo-1586985289688-ca3cf47d3e6e?w=800&q=80',
    category: 'weddings',
    alt: 'Elegant wedding cake',
  },
  {
    id: 15,
    url: 'https://images.unsplash.com/photo-1576618148400-f54bed99fcfd?w=800&q=80',
    category: 'cupcakes',
    alt: 'Gourmet cupcakes',
  },
  {
    id: 16,
    url: 'https://images.unsplash.com/photo-1524351199678-941a58a3df50?w=800&q=80',
    category: 'custom',
    alt: 'Unique custom cake',
  },
]

// Flavor Categories for Cake Builder (based on menu)
export const flavorCategories = [
  {
    id: 'indian-fusion',
    name: 'Indian Fusion Cakes',
    priceCategory: 'premium',
    flavors: [
      { id: 'rasmalai', name: 'Rasmalai Cake', color: '#FFF4E6' },
      { id: 'gulab-jamun', name: 'Gulab Jamun Cake', color: '#8B4513' },
      { id: 'rabri-jalebi', name: 'Rabri Jalebi Cake', color: '#FF8C00' }
    ]
  },
  {
    id: 'classic',
    name: 'Classic Cakes',
    priceCategory: 'classic',
    flavors: [
      { id: 'vanilla', name: 'Vanilla Cake', color: '#FFF5E1' },
      { id: 'black-forest', name: 'Black Forest Cake', color: '#3E2723' },
      { id: 'white-forest', name: 'White Forest Cake', color: '#F5F5DC' },
      { id: 'chocolate-mousse', name: 'Chocolate Mousse Cake', color: '#6F4E37' }
    ]
  },
  {
    id: 'fresh-fruit',
    name: 'Fresh Fruit Cakes',
    priceCategory: 'premium',
    flavors: [
      { id: 'pineapple', name: 'Pineapple Cake', color: '#FFE135' },
      { id: 'mixed-fruit', name: 'Mixed Fruit Cake (Seasonal)', color: '#FF6B6B', seasonal: true },
      { id: 'mango', name: 'Mango Cake (Seasonal)', color: '#FFB347', seasonal: true },
      { id: 'blueberry', name: 'Blueberry Cake', color: '#4169E1' },
      { id: 'strawberry', name: 'Strawberry Cake', color: '#FFB3C1' }
    ]
  },
  {
    id: 'special',
    name: 'Special Cakes',
    priceCategory: 'premium',
    flavors: [
      { id: 'dark-chocolate', name: 'Dark Chocolate Cake', color: '#3E2723' },
      { id: 'matilda', name: 'Matilda Cake', color: '#4A2C2A' },
      { id: 'tiramisu', name: 'Tiramisu Cake', color: '#D2B48C', note: 'with or without alcohol' },
      { id: 'honey-medovik', name: 'Honey Cake (Medovik)', color: '#F4A460' }
    ]
  }
]

// Helper function to get all flavors as a flat list
export const getAllFlavors = () => {
  return flavorCategories.flatMap(category =>
    category.flavors.map(flavor => ({
      ...flavor,
      categoryId: category.id,
      categoryName: category.name,
      priceCategory: category.priceCategory
    }))
  )
}

// Legacy export for backward compatibility
export const flavorOptions = getAllFlavors()

// Size Options for Cake Builder (with category-based pricing from menu)
export const sizeOptions = [
  { id: 'S', name: 'Small', servings: 4, priceClassic: 32, pricePremium: 35 },
  { id: 'M', name: 'Medium', servings: 6, priceClassic: 38, pricePremium: 42 },
  { id: 'L', name: 'Large', servings: '8-10', priceClassic: 48, pricePremium: 52 },
  { id: 'XL', name: 'X-Large', servings: '12-15', priceClassic: 65, pricePremium: 70 },
  { id: '2XL', name: '2X-Large', servings: '20-25', priceClassic: 80, pricePremium: 85 },
  { id: '3XL', name: '3X-Large', servings: '30-35', priceClassic: 110, pricePremium: 120 },
]

// 2-tier eligibility: only chocolate flavors in the two largest sizes.
// Single source of truth for the rule, used by the builder UI, the context
// auto-reset logic, and order validation.
export const TWO_TIER_FLAVOR_IDS = ['dark-chocolate', 'chocolate-mousse']
export const TWO_TIER_SIZE_IDS = ['2XL', '3XL']
export const is2TierAllowed = (flavorId, sizeId) =>
  TWO_TIER_FLAVOR_IDS.includes(flavorId) && TWO_TIER_SIZE_IDS.includes(sizeId)

// Theme Options for Cake Builder
export const themeOptions = [
  { id: 'none', name: 'Standard (No Theme)' },
  { id: 'peppa-pig', name: 'Peppa Pig' },
  { id: 'frozen', name: 'Frozen' },
  { id: 'lego', name: 'Lego' },
  { id: 'mermaid', name: 'Mermaid' },
  { id: 'unicorn', name: 'Unicorn' },
  { id: 'dinosaur', name: 'Dinosaur' },
  { id: 'superhero', name: 'Superhero' },
]


// Cake toppers (+€2 for any topper). Shared by the order form and WhatsApp summary.
export const cakeTopperOptions = [
  { id: 'none', name: 'No Topper' },
  { id: 'birthday-golden', name: 'Happy Birthday (Golden)' },
  { id: 'birthday-black', name: 'Happy Birthday (Black)' },
  { id: 'anniversary-golden', name: 'Happy Anniversary (Golden)' },
  { id: 'anniversary-black', name: 'Happy Anniversary (Black)' },
  { id: 'baby-shower', name: 'Baby Shower' },
]
export const getCakeTopperName = (id) =>
  cakeTopperOptions.find((t) => t.id === id)?.name || id

// Frosting sweetness. The sponge is unchanged, and there is no price change.
export const frostingSweetnessOptions = [
  { id: 'normal', name: 'Normal sugar' },
  { id: 'less-20', name: '20% less sugar' },
  { id: 'less-50', name: '50% less sugar' },
  { id: 'none', name: 'No sugar' },
]
export const getFrostingSweetnessName = (id) =>
  frostingSweetnessOptions.find((o) => o.id === id)?.name || id

// How much frosting. No price change.
export const frostingAmountOptions = [
  { id: 'normal', name: 'Normal creamy' },
  { id: 'less', name: 'Less cream' },
  { id: 'more', name: 'More cream' },
]
export const getFrostingAmountName = (id) =>
  frostingAmountOptions.find((o) => o.id === id)?.name || id

// Who the order is for (optional, free text via 'Other').
export const orderingForOptions = ['Baby', 'Kid', 'Teenager', 'Wife', 'Husband', 'Girlfriend', 'Boyfriend', 'Friend', 'Parent', 'Colleague', 'Myself', 'Other']

// ── Cupcakes ──
// Cupcake flavours have two price tiers (standard vs premium). Note: the ids
// 'vanilla' and 'blueberry' overlap with cake flavour ids, so any code that
// resolves a cupcake flavour MUST branch on productType === 'cupcake' first and
// use the cupcake helpers below — never the cake lookups (getAllFlavors etc.).
export const cupcakeFlavors = [
  { id: 'vanilla', name: 'Vanilla', priceTier: 'standard', color: '#FFF5E1' },
  { id: 'chocolate', name: 'Chocolate', priceTier: 'standard', color: '#3E2723' },
  { id: 'blueberry', name: 'Blueberry', priceTier: 'premium', color: '#4F6BED' },
  { id: 'carrot', name: 'Carrot', priceTier: 'premium', color: '#E8923A' },
]

// Per-unit price by size and flavour tier.
export const cupcakeSizes = [
  { id: 'mini', name: 'Mini', subtitle: 'Bite-size', priceStandard: 2.0, pricePremium: 2.5 },
  { id: 'small', name: 'Small', priceStandard: 2.75, pricePremium: 3.25 },
  { id: 'standard', name: 'Standard', priceStandard: 3.75, pricePremium: 4.25 },
]

// Custom design levels. 'simple' adds a flat per-unit surcharge that is included
// in the live price; 'detailed' is quoted later by the baker (€0 in the instant price).
export const cupcakeDesignOptions = [
  { id: 'none', name: 'No custom design', surcharge: 0 },
  { id: 'simple', name: 'Simple (theme, colours, piping)', surcharge: 0.5 },
  { id: 'detailed', name: 'Detailed (florals / toppers)', surcharge: 0, quotedLater: true },
]

export const CUPCAKE_MIN_QUANTITY = 6

export const getCupcakeFlavorName = (id) =>
  cupcakeFlavors.find((f) => f.id === id)?.name || id

export const getCupcakeSizeName = (id) =>
  cupcakeSizes.find((s) => s.id === id)?.name || id

export const getCupcakeDesignName = (id) =>
  cupcakeDesignOptions.find((d) => d.id === id)?.name || id

// Gallery Filter Categories
export const galleryCategories = [
  { id: 'all', name: 'All Designs' },
  { id: 'weddings', name: 'Weddings' },
  { id: 'birthdays', name: 'Birthdays' },
  { id: 'seasonal', name: 'Seasonal' },
  { id: 'cupcakes', name: 'Cupcakes' },
  { id: 'custom', name: 'Custom' },
]
